export const BUGSNAG_ID = 'e755adf921461dae02ab552c23f6c277';
